import actionType from '../actions/type';

export default (state = {}, action) => {
  switch (action.type) {
    case actionType.GET_PREFERENCE:
      return { ...state, preference: action.payload };
    case actionType.TOGGLE_MUTE:
      return state;
    default:
      return state;
  }
};
